export interface TimelineSettings {
  redirectTopLevel: boolean;
  redirectUrl: string;
}

type TimelineSettingsInput = Partial<TimelineSettings> | undefined;

declare global {
  interface Window {
    __TIMELINE_SETTINGS__?: TimelineSettingsInput;
  }
}

export function readTimelineSettings(
  input: TimelineSettingsInput = window.__TIMELINE_SETTINGS__
): TimelineSettings {
  return {
    redirectTopLevel: input?.redirectTopLevel === true,
    redirectUrl: typeof input?.redirectUrl === "string" ? input.redirectUrl : ""
  };
}

export function getRedirectUrl(
  settings: TimelineSettings,
  isTopLevelWindow: boolean,
  currentUrl: string
): string | undefined {
  if (!settings.redirectTopLevel || !isTopLevelWindow || !settings.redirectUrl) {
    return undefined;
  }

  let redirectUrl: URL;
  let currentLocation: URL;

  try {
    redirectUrl = new URL(settings.redirectUrl);
    currentLocation = new URL(currentUrl);
  } catch {
    return undefined;
  }

  if (redirectUrl.protocol !== "https:" || redirectUrl.href === currentLocation.href) {
    return undefined;
  }

  return redirectUrl.href;
}

export function isTopLevelWindow(): boolean {
  try {
    return window.self === window.top;
  } catch {
    // Treat inaccessible window relationships as embedded so the redirect
    // cannot break the timeline.
    return false;
  }
}
